import React from 'react'

export default function PageMaintenance() {
  return (
    <div className="font-nunito flex flex-col items-center justify-center h-screen bg-gray-100 gap-y-2 p-5">
        <img 
            src="/assets/pxch/yellow_icon_name.webp"
            alt="Maintenance" 
            className="mb-8 h-[200px] w-[200px]"
         />
        <h1 className="text-2xl sm:text-4xl text-center font-bold text-gray-800 mb-6 ">Software and Platform Upgrade in Progress</h1>
        <p className="text-center text-xl sm:text-2xl text-gray-600 mb-8 max-w-[800px] leading-relaxed">We're  making things better for you, we apologize for the inconvenience and appreciate your patience.<br/>PXCH will be back in the morning!!!</p>

    </div>   
  )
}







